'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Role pivileges based on graph.
 */

/**
 * GSQL Role.
 */

var RoleType = /*#__PURE__*/function (RoleType) {
  RoleType["Global"] = "Global";
  RoleType["Local"] = "Local";
  return RoleType;
}({});

exports.RoleType = RoleType;
